import React, { Component } from "react";
import styled from "styled-components";

import { Popover } from "@material-ui/core";

import { ds } from "js/core/models/dataService";

import { AdvanceSlideOnType } from "common/constants";
import { SlideOptionsDialog } from "./SlideOptionsDialog";

const StyledPopover = styled(Popover)`
    &&& {
        margin-left: 14px;

        .MuiPaper-root {
            overflow: visible;
        }
    }
`;

const PopoverTriangle = styled.div`
    position: absolute;
    left: 0;
    top: 50%;
    transform: translate(-100%, -50%);

    width: 0; 
    height: 0; 
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent; 
    
    border-right:10px solid #ffffff;
`;

const defaultSlideState = {
    advanceOn: AdvanceSlideOnType.CLICK,
    advanceDelay: 5,
    hasAudioAsset: false
};

export class SlideAdvanceOptionsPopup extends Component {
    constructor() {
        super();

        this.state = {
            ...defaultSlideState,
            isPopoverOpen: false
        };

        this.currentSlide = null;
        this.iconRef = React.createRef();
    }

    componentDidMount() {
        const { editor } = this.props;

        ds.selection.on("change:slide", this.onSelectionChanged);

        // Set correct slide once editor is ready
        editor.once("editor-ready", () => this.onSelectionChanged(ds.selection));
    }

    componentWillUnmount() {
        ds.selection.off("change:slide", this.onSelectionChanged);
        if (this.currentSlide) {
            this.currentSlide.off("change", this.onCurrentSlideChanged);
        }
    }

    onSelectionChanged = ({ slide }) => {
        if (slide === this.currentSlide) {
            return;
        }

        if (this.currentSlide) {
            this.currentSlide.off("change", this.onCurrentSlideChanged);
        }

        if (slide) {
            this.currentSlide = slide;
            this.currentSlide.on("change", this.onCurrentSlideChanged);
            this.onCurrentSlideChanged();
        } else {
            this.currentSlide = null;
        }
    }

    onCurrentSlideChanged = () => {
        const hasAudioAsset = this.currentSlide.has("audioAsset");

        let advanceOn = this.currentSlide.get("advanceOn") ?? defaultSlideState.advanceOn;
        if (advanceOn === AdvanceSlideOnType.AUDIO && !hasAudioAsset) {
            advanceOn = AdvanceSlideOnType.CLICK;
        }

        this.setState({
            advanceOn,
            advanceDelay: this.currentSlide.get("advanceDelay") ?? defaultSlideState.advanceDelay,
            hasAudioAsset
        });
    }

    handleUpdateSlide = ({ advanceOn = undefined, advanceDelay = undefined }) => {
        if (!this.currentSlide) {
            return;
        }

        const updates = {};
        if (advanceOn !== undefined) {
            updates.advanceOn = advanceOn;
        }
        if (advanceDelay !== undefined) {
            updates.advanceDelay = advanceDelay;
        }

        this.currentSlide.update(updates);
    }

    handleOpenPopover = () => {
        const { editor } = this.props;
        if (editor.isShowingSideBar) {
            editor.hideSideBar(true);
        }

        this.setState({ isPopoverOpen: true });
    }

    handleClosePopover = () => {
        this.setState({ isPopoverOpen: false });
    }

    render() {
        const {
            advanceOn,
            advanceDelay,
            hasAudioAsset,
            isPopoverOpen
        } = this.state;

        const getAdvancePopupButtonIconName = advanceOn => {
            switch (advanceOn) {
                case AdvanceSlideOnType.AUDIO:
                    return "audiotrack";
                case AdvanceSlideOnType.DELAY:
                    return "timer";
                default:
                    return "mouse";
            }
        };

        return (<>
            <div
                className="menu_button animation-icon"
                onClick={this.handleOpenPopover}
            >
                <i className="micon" ref={this.iconRef}>
                    {getAdvancePopupButtonIconName(advanceOn)}
                </i>
                <label>Next Slide</label>
            </div>
            <StyledPopover
                anchorEl={this.iconRef.current}
                open={isPopoverOpen}
                onClose={this.handleClosePopover}
                anchorOrigin={{
                    vertical: "center",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "center",
                    horizontal: "left",
                }}
            >
                <PopoverTriangle />
                <SlideOptionsDialog
                    advanceOn={advanceOn}
                    advanceDelay={advanceDelay}
                    hasAudioAsset={hasAudioAsset}
                    updateSlide={this.handleUpdateSlide}
                />
            </StyledPopover>
        </>);
    }
}
